import * as RouterEffects from './router.effect';
import * as MetaEffects from './meta.effect';
import * as ThemeEffects from './theme.effect';

export const appEffects = { ...RouterEffects, ...MetaEffects, ...ThemeEffects };
